import React, { useState, useEffect } from 'react';
import { TabsNavbar, ReadyGroups, NewGroups, ClosedGroups, User, UserDetails } from '../components';
import { API_BASE_URL } from '../utils/apiConfig'; // Import API_BASE_URL
import { useUserContext } from '../context/user_context';
import { useCompanySubscriberContext } from '../context/companysubscriber_context';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import GroupDataInNavbar from '../components/GroupDataInNavbar';
import loadingImage from '../images/preloader.gif';
//for ledger account
import { useLedgerAccountContext } from "../context/ledgerAccount_context"; 
import { useLedgerEntryContext } from "../context/ledgerEntry_context"; 


const HomePage = () => {
  const history = useHistory();
  const [selectedTab, setSelectedTab] = useState('ready');
  const [groups, setGroups] = useState([]);
  const [subscribers, setSubscribers] = useState([]);
  const [premium, setPremium] = useState([]);
  const [profits, setProfits] = useState([]);

  const { isLoggedIn, user, isLoading, setIsLoading } = useUserContext();
  const [membershipId, setMembershipId] = useState('');
  // const { state, dispatch } = useCompanySubscriberContext();
  // const { state, dispatch } = useGroupDetailsContext();

  // Use distinct variable names for state and dispatch from different contexts
  const { state: companySubscriberState, dispatch: companySubscriberDispatch } = useCompanySubscriberContext();
  const { fetchLedgerAccounts } = useLedgerAccountContext();
  const { fetchLedgerEntries } = useLedgerEntryContext();

  




    const fetchGroups = async () => {
      try {
        setIsLoading(true);
        const apiUrl = `${API_BASE_URL}/users/groups`; // Construct the API URL using API_BASE_URL

        const response = await fetch(apiUrl, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${user?.results?.token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch groups');
        }

        const data = await response.json();
        console.log('mani into home page');
        console.log(data);



        if (data.results.groups && data.results.groups.length > 0) {
          console.log('came into if condition');
          console.log(data.results.groups);
          setGroups(data.results.groups); // Set the data.results array into groups

        }
        if (data.results.earnedPremium && data.results.earnedPremium.length > 0) {
          console.log('came into if condition');
          console.log(data.results.earnedPremium);
          setPremium(data.results.earnedPremium); // Set the data.results array into groups

        }
        if (data.results.subscribers && data.results.subscribers.length > 0) {
          setSubscribers(data.results.subscribers); // Set the data.results array into groups
          companySubscriberDispatch({ type: 'SET_SUBSCRIBERS', payload: data.results.subscribers });

        }





      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };

  useEffect(() => {
    fetchGroups();
    fetchLedgerAccounts();
    fetchLedgerEntries();
  }, [user, setIsLoading]); // Include user as a dependency

  // Log groups in a useEffect with a dependency on groups
  useEffect(() => {
    console.log(groups);
  }, [groups]);

  useEffect(() => {
    if (user.results.userAccounts && user.results.userAccounts.length > 0) {

      const membership = user.results.userAccounts[0];
      console.log(membership.membershipId);
      setMembershipId(membership.membershipId);
    }
  }, [user]);

  const handleStartGroup = () => {
    // Add your logic here for what happens when the button is clicked
    history.push('/startagroup');
    // You can perform navigation or other actions here.
  };
  const handleStartCompany = () => {
    // Add your logic here for what happens when the button is clicked
    history.push('/company');
    // You can perform navigation or other actions here.
  };
  const handleAddCompanySubcriber = (membershipId) => {
    history.push(`/addcompanysubscriber/${membershipId}`);
  };

  if (isLoading) {
    return (
      <>
        <img src={loadingImage} className='loading-img' alt='loding' />
        <div className="placeholder" style={{ height: '50vh' }}></div>
      </>
    );
  }


  return (<section className='section'>
    <Wrapper className='section-center'>

      <div class="list-container">
        <div >
          {localStorage.getItem('unauthenticatedGroup') && <GroupDataInNavbar />}
        </div>
        <UserDetails groups={groups} subscribers={subscribers} premium={premium} />



        < div class="grid-2" >
          <h3>My Groups ({groups.length})</h3>
          <div style={{ marginTop: "24px" }}>
            {groups.length === 0 ? (
              <>
                <button className="start-group-button" onClick={handleStartGroup}>
                  Start a group
                </button>
              </>
            ) : (
              <>
                <TabsNavbar
                  selectedTab={selectedTab}
                  onSelectTab={(tab) => setSelectedTab(tab)}
                  groups={groups}
                />
                {selectedTab === 'ready' ? (
                  <ReadyGroups groups={groups} selectedTab={selectedTab} />
                ) : selectedTab === 'new' ? (
                  <NewGroups groups={groups} selectedTab={selectedTab} refreshGroups={fetchGroups} />
                ) : (
                  <ClosedGroups groups={groups} /> // 👈 Add this for closed
                )}
              </>
            )}
          </div>
        </div >
        
      </div >
    </Wrapper >
  </section >
  );
}
const Wrapper = styled.section`

min-height: 300vh;
 display: list;    
padding-top:20px;

   .list-container {
    display: list; 
    
    
  }
  
  .grid-1 {
  

    padding-top: 2rem;
display: grid;
gap: 3rem 2rem;
@media (min-width: 992px) {
  grid-template-columns: 1fr 1fr;
}

  }
  
  .fraction-1 {
   display:flex;
  
    text-align: center;
    flex-direction: column;
    
  }
  
  /* Add styling for the dashboard boxes */
  .dashboard-box {
    background-color: #ffffff;
    border-radius: 10px;
    padding: 15px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    text-align: center;
    margin: 10px;
    width:10rem;
  }
  
  .dashboard-box h4 {
    font-size: 18px;
    color: #333;
  }
  
  .dashboard-box p {
    font-size: 24px;
    font-weight: bold;
    color: #007bff; /* Change the color to your preference */
  }
  
  /* Additional styles for .fraction-2 */
  .fraction-2 {
    
    display: grid;
    grid-template-columns: auto auto auto;
    align-items: center;
    justify-content: left;
    column-gap: 1rem;
    row-gap: 2px;
    margin-bottom: 3rem;
    
    
  }
  
  .mini-dashboard {
    display: flex;
    flex-direction: row;
    padding-left:8rem;
    
  }
  
  .grid-2,
  .grid-3 {
    background-color: #f0f0f0;
  padding: 20px; /* Adjust padding as needed */
  text-align: left;
  margin-top: 20px; /* Add margin at the top as needed */
  border-radius: 10px; /* Add border radius for rounded corners */

}
  }
  
  
  /* Additional styles for the button and victory cup image */
.start-group-button { 
  background-color: var(--clr-red-dark);
  color: #fff; /* Button text color */
  border: none;
  border-radius: 10px;
  padding: 10px 50px;
  width:200px;
  margin: 10px 60px; /* Adjust the margin as needed */
  cursor: pointer;
  display: flex;
  align-items: center;
}

.add-customer-button {
    background: transparent;
    border-color: transparent;
    width: 4rem;
    height: 4rem;
    background: var(--clr-red-dark);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: var(--clr-white);
    cursor: pointer;
    margin-left: 2rem;
    margin-top: 1px;
    align-self: center;
    min-width: 2rem;
  
}

.start-group-button img {
  width: 20px; /* Adjust the width of the victory cup image */
  margin-left: 10px; /* Add spacing between text and image */
}
  @media (min-width: 992px) 
  {
    height: calc(100vh - 5rem);
    
  }

  .start-group-button {
    background-color: var(--clr-red-dark);
    color: #fff;
    border: none;
    border-radius: 10px;
    padding: 10px 50px;
    width: 200px;
    margin: 10px auto; /* Center horizontally */
    display: flex;
    align-items: center;
    justify-content: center; /* Center vertically */
    cursor: pointer;
  }
`

export default HomePage;
